import { ModalAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import GuidanceAndRegulatory from '../../interfaces/guidance-and-regulatory';
import { cast } from '../../utils/cast-helpers';
import { DelayedExecutor } from '../../utils/workaround-utils';
import BaseController from '../BaseController';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationModulesIds } from '../../app/module-registry/application-modules';

@Controller({ component: 'root-modal', fragment: 'guidance-and-regulatory-modal' })
export default class GuidanceAndRegualtoryController extends BaseController {

  @Inject('root-modal')
    rootModal!: ModalAPI;

  private delayedExecutor: DelayedExecutor<GuidanceAndRegulatory> = new DelayedExecutor();

  @OnAfterFetch({ target: 'fetch-guidance-and-regulatory' })
  onAfterFetchUpdateModalTitle(event: FetchEvent): void {
    this.delayedExecutor.completeNow(cast(event.data));
  }

  @OnClose({ target: 'root-modal' })
  onRootModalClose(): void {
    applicationContext.openModule(ApplicationModulesIds.PROFILE);
  }

}
